// extracted by mini-css-extract-plugin
export default {"container":"TerritoriesCellRenderer_container__-SCvj","tag":"TerritoriesCellRenderer_tag__mmJ5z"};